<script>
  import { onDestroy, onMount, tick } from "svelte";
  import { getNotificationsContext } from "svelte-notifications"
  import {useQuery} from "@sveltestack/svelte-query"
  import DialogBase2 from "../dialog/DialogBase2.svelte";
  import DialogTitle from "../dialog/DialogTitle.svelte";
  import { translate } from "../../i18n/i18next.js";
  import DialogSplitter from "../dialog/DialogSplitter.svelte";
  import DialogContent from "../dialog/DialogContent.svelte";
  import ManageRestrictionsTitle from "./RestrictedUserInvitationDialog/ManageRestrictionsTitle.svelte";
  import SelectRestrictions from "./RestrictedUserInvitationDialog/SelectRestrictions.svelte";
  import Loading from "../pages/Loading.svelte";
  import DialogBottomControls from "../dialog/DialogBottomControls.svelte";
  import DialogBottomControlButton from "../dialog/DialogBottomControlButton.svelte";
  import {submitRestrictions} from "./RestrictedUserInvitationDialog/utils.js";

  export let user
  export let projectId
  export let closeDialog

  let dialog = null
  onMount(async () => {
    await tick()
    dialog?.showModal()
  })
  onDestroy(() => {
    dialog?.close()
  })

  let resourceObjectIdToRoleMap = null
  const query = useQuery(`/api/projects/${projectId}/users/${user.id}/restrictions`, {refetch: false})
  query.subscribe(query => {
    if (query.isSuccess && !resourceObjectIdToRoleMap) {
      resourceObjectIdToRoleMap = query.data.resourceObjectIdToRoleMap
    }
  })

  let isSubmitting = false
  const {addNotification} = getNotificationsContext()
  async function submit() {
    const ok = await submitRestrictions(projectId, user.id, resourceObjectIdToRoleMap)
    if (ok) {
      addNotification({
        text: translate("frontend:components.manageRestrictedUserRestrictionDialog.messages.restrictionSaved"),
        type: "success",
        removeAfter: 4000,
        position: "top-right",
      })
      closeDialog()
    } else {
      addNotification({
        text: translate("frontend:components.manageRestrictedUserRestrictionDialog.messages.restrictionSaveFailed"),
        type: "error",
        removeAfter: 4000,
        position: "top-right",
      })
      isSubmitting = false
    }
  }
</script>

<DialogBase2 bind:dialog={dialog} width="700px">
  <DialogTitle>{translate("frontend:components.manageRestrictedUserRestrictionDialog.title")}</DialogTitle>
  <DialogSplitter />
  <DialogContent>
    <ManageRestrictionsTitle
      user={user}
    />
    {#if !resourceObjectIdToRoleMap}
      <Loading height="300px" />
    {:else}
      <SelectRestrictions
        projectId={projectId}
        bind:resourceObjectIdToRoleMap={resourceObjectIdToRoleMap}
      />
    {/if}
  </DialogContent>
  <DialogBottomControls>
    <DialogBottomControlButton onClick={submit} disabled={isSubmitting}>
      {translate("generic.save")}
    </DialogBottomControlButton>
    <DialogBottomControlButton type="secondary" onClick={() => closeDialog()}>
      {translate("generic.cancel")}
    </DialogBottomControlButton>
  </DialogBottomControls>
</DialogBase2>
